import React, { useEffect, useState } from "react";
import { Card, Col } from "react-bootstrap";
import useBorrowerDashboardTwo from "./apis/useBorrowerDashboardTwo";
import PopupWrapper from "../../../components/PopupWrapper";
import ErrorBoundary from "../../../components/ErrorBoundary";
import CommonGrid from "../../../components/CommonGrid";
import { gridColumns_PortfolioAtGlanceBorrower } from "../../../Utils/TableColumnDefs";
import { useDispatch, useSelector } from "react-redux";
import { fetchBorrowerPortfolioLoans } from "../../../store/reducers/dashboardSlice/api";
import { ComingSoonWrapper } from "./Payments";

const summaryData = [
  {
    field: "active",
    label: "Total Active Loans",
    color: "text-primary",
    tooltip:
      "Number of loans that are currently open and in repayment or disbursement.",
  },
  {
    field: "total",
    label: "Total Loan Count",
    color: "text-primary",
    tooltip:
      "Total number of loans associated with this account, including paid-off ones.",
  },
  {
    field: "paidOff",
    label: "Paid off Loans",
    color: "text-primary",
    tooltip: "Loans that have been fully paid and are no longer active.",
  },
  {
    field: "foreclosure",
    label: "Loans in Foreclosure",
    color: "text-primary",
    tooltip: "Loans that are currently in the foreclosure process.",
  },
];

export const AccountSummary = () => {
  const [show, setShow] = useState(false);
  const [category, setCategory] = useState(null);
  const [title, setTitle] = useState("");
  const data = useSelector(
    (state) => state.dashboard.borrowerPortfolioLoans.data
  );
  const status = useSelector(
    (state) => state.dashboard.borrowerPortfolioLoans.status
  );
  const {
    borrowerAccountsSummary,
    paidoffAccountList,
    totalAccountList,
    activeAccountList,
    foreclosureLoansList,
  } = useBorrowerDashboardTwo();
  const dispatch = useDispatch();

  useEffect(() => {
    if (category === "active") {
      dispatch(
        fetchBorrowerPortfolioLoans({
          requestBody: {
            borrowerRecID: activeAccountList?.map((el) => el.value).join(" "),
          },
        })
      );
    } else if (category === "total") {
      dispatch(
        fetchBorrowerPortfolioLoans({
          requestBody: {
            borrowerRecID: totalAccountList?.map((el) => el.value).join(" "),
          },
        })
      );
    } else if (category === "paidOff") {
      dispatch(
        fetchBorrowerPortfolioLoans({
          requestBody: {
            borrowerRecID: paidoffAccountList?.map((el) => el.value).join(" "),
          },
        })
      );
    } else if (category === "foreclosure") {
      dispatch(
        fetchBorrowerPortfolioLoans({
          requestBody: {
            borrowerRecID: foreclosureLoansList
              ?.map((el) => el.value)
              .join(" "),
          },
        })
      );
    }
  }, [
    category,
    paidoffAccountList?.length,
    totalAccountList?.length,
    activeAccountList?.length,
    foreclosureLoansList?.length,
  ]);

  function handleCategorySelection(item) {
    setShow((prev) => !prev);
    setCategory(item.field);
    setTitle(item.label);
  }

  return (
    <Card className="border border-primary h-100 p-4 account-summary">
      <h5 className="text-center p-3">Accounts Summary</h5>
      <div className="d-flex justify-content-between px-3 py-3">
        {summaryData.map((item, index) => (
          <div
            key={index}
            className="d-flex flex-column align-items-center"
            // title={item.tooltip}
          >
            <ComingSoonWrapper label={item.label} tooltip={item.tooltip}>
              <div
                className={`d-flex justify-content-center align-items-center shadow ${item.color} hover-effect-accounts`}
                style={{
                  width: "80px",
                  height: "80px",
                  borderRadius: "50%",
                  border: "2px solid navy",
                }}
                role="button"
                onClick={() => handleCategorySelection(item)}
              >
                {borrowerAccountsSummary?.[item.field] !== "null"
                  ? borrowerAccountsSummary?.[item.field]
                  : "-"}
              </div>
            </ComingSoonWrapper>
            <p className="small mt-2 text-center" title={item.label}>
              {item.label}
            </p>
          </div>
        ))}
      </div>
      <PortfolioLoansModal
        show={show}
        setShow={setShow}
        data={data}
        status={status}
        title={title}
      />
    </Card>
  );
};

export default AccountSummary;

export const PortfolioLoansModal = ({
  show,
  setShow,
  title,
  status,
  data,
  tableTotal = "principal",
  gridColumns = gridColumns_PortfolioAtGlanceBorrower,
}) => {
  return (
    <>
      <PopupWrapper
        Component={
          <ErrorBoundary>
            <CommonGrid
              status={status}
              className={``}
              title={title}
              gridColumns={gridColumns}
              columnData={data}
              tableTotal={[tableTotal]}
              viewAllModal={false}
            />
          </ErrorBoundary>
        }
        title={title}
        toShow={show}
        closeEventHandler={() => {
          setShow(false);
        }}
      />
    </>
  );
};

export const LoansTable = ({
  status,
  data,
  tableTotal = "principal",
  gridColumns = gridColumns_PortfolioAtGlanceBorrower,
  title = ""
}) => {
  return (
    <div>
      <ErrorBoundary>
        <CommonGrid
          status={status}
          className={``}
          title={title}
          gridColumns={gridColumns}
          columnData={data}
          tableTotal={[tableTotal]}
          viewAllModal={false}
        />
      </ErrorBoundary>
    </div>
  );
};
